import { useCallback, useMemo } from "react"
import { useParams } from "react-router-dom"
import { useDeviceSoftwarePackageFirmwareConstraints } from "../../../../../hooks/useDeviceSoftwarePackageFirmwareConstraints"
import { DimaFeatureShortNameEnum } from "../../../../models/Authorization"
import { DeviceSoftwarePackageFirmwareConstraintGet } from "../../../../models/DeviceSoftwarePackageFirmwareConstraint"
import { useDeleteConfirm } from "../../../../../hooks/useDeleteConfirm"
import { deleteEntity } from "../../../../utils/deleteEntity"
import { DiMaAddButton } from "../../../partials/DiMaAddButton"
import { EntityRow, EntityTab } from "../../../partials/EntityTab"

export function DeviceSoftwarePackageFirmwareConstraints() {
  const { deviceId } = useParams()
  const { requestDelete, DeleteConfirmDialog } = useDeleteConfirm()

  const {
    deviceSoftwarePackageFirmwareConstraints,
    isLoadingDeviceSoftwarePackageFirmwareConstraints,
  } = useDeviceSoftwarePackageFirmwareConstraints(deviceId)

  const columns = [
    {
      field: "softwarePackageEditionCode",
      headerName: "SW Package Edition Code",
      isLink: true,
      linkBasePath: `/devices/${deviceId}/software-package-firmware-constraints`,
    },
    { field: "mainboardMinSoftwareVersion", headerName: "Mainboard Min SW Version" },
    { field: "hmiMinSoftwareVersion", headerName: "HMI Min SW Version" },
  ]

  const sorted = [...deviceSoftwarePackageFirmwareConstraints].sort((a, b) =>
    (a.softwarePackageEditionCode ?? "").localeCompare(b.softwarePackageEditionCode ?? "")
  )

  const rows = sorted.map((c: DeviceSoftwarePackageFirmwareConstraintGet) => ({
    id: c.id,
    softwarePackageEditionCode: c.softwarePackageEditionCode,
    mainboardMinSoftwareVersion: c.mainboardMinSoftwareVersion,
    hmiMinSoftwareVersion: c.hmiMinSoftwareVersion,
  }))

  const toolbar = useMemo(
    () => (
      <DiMaAddButton
        url={`/devices/${deviceId}/software-package-firmware-constraints/create`}
        feature={DimaFeatureShortNameEnum.AM}
      />
    ),
    [deviceId]
  )

  const handleActionMenuClick = useCallback((item: { title: string }, row: EntityRow) => {
      if (item.title === "Delete") {
        requestDelete(() =>
          deleteEntity(
            `/devices/${deviceId}/softwarePackageFirmwareConstraints/${row.id}`
          )
        )
      }
    }, [deviceId, requestDelete])

  return (
    <>
      {DeleteConfirmDialog}
      <EntityTab
        rows={rows}
        cols={columns}
        isLoading={isLoadingDeviceSoftwarePackageFirmwareConstraints}
        toolbar={toolbar}
        actionItems={[{ title: "Delete", iconName: "icon_abb_dias icon-abb_delete" }]}
        onActionMenuClick={handleActionMenuClick}
      />
    </>
  )
}
